export default __webpack_public_path__ + "static/media/08.f249c24d.jpg";